module.exports = __webpack_public_path__ + "media/morning-routine.2c71c143.mp4";